import React, { Dispatch, SetStateAction, createContext, useState } from 'react';

import { MessagesContainer } from '../../components/message/messageContainer/MessagesContainer';
import { MessagesContextControllerProps, MessagesContextStateType } from './MessagesContextController.types';

/**
 * Context that holds the current messages state
 */
export const MessagesContextState = createContext<MessagesContextStateType | undefined>(undefined);

/**
 * Context that provides a function to update the messages state
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const MessagesContextDispatch = createContext<Dispatch<SetStateAction<MessagesContextStateType>>>(() => {});

/**
 * Provider component that enables the message notification system
 * Must be included near the root of your application
 */
export const MessagesContextController = ({ children }: MessagesContextControllerProps) => {
  const [messages, setMessages] = useState<MessagesContextStateType>([]);

  /**
   * Handles removing a message when it's closed
   *
   * @param {string | number} id - The ID of the message to close
   */
  const handleCloseMessage = (id: string | number) => {
    const currentMessages = messages.slice();
    const filteredMessages = currentMessages.filter(message => message.id !== id);
    setMessages(filteredMessages);
  };

  return (
    <MessagesContextState.Provider value={messages}>
      <MessagesContextDispatch.Provider value={setMessages}>
        <MessagesContainer messages={messages} onClose={handleCloseMessage} />
        {children}
      </MessagesContextDispatch.Provider>
    </MessagesContextState.Provider>
  );
};
